import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/chocolate.png";
import BiscuitImg from "../../../assets/products/crispy bites/Chocolate-Biscuites.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 30,
  },
  {
    grams: 60,
  },
  {
    grams: 135,
  },
  {
    grams: 175,
  },
  {
    grams: 500,
  },
];

export default function ChocolateProduct() {
  return (
    <>
      <Helmet>
        <title>
          Crispy Chocolate Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Chocolate Biscuits — rich cocoa flavor with a satisfying crunch. View pack sizes, carton details, and global specs."
        />
        <meta
          name="keywords"
          content="Crispy Chocolate Biscuit, BearBitz Chocolate Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/chocolate"
        />
        <meta
          property="og:title"
          content="Crispy Chocolate Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Deliciously crispy and chocolaty biscuits by BearBitz, crafted for taste and global export quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="BOURBON"
        productImage={BisImg}
        description="Double the Cocoa, Double the Delight. Chocolaty crunch and creamy center—an irresistible treat for all ages. A classic indulgence that travels well and sells fast."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#68171A"
        sectionBgColor="#FFDDA4"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#68171A"
        tableBgcolor="#FFF2DC"
        footerBgcolor="#68171A"
      />
    </>
  );
}
